import { endpoints } from '../api/endpoints';
import * as api from '../api/base';
import queryString from 'query-string';


export const isOrgNameDuplicate = async (organizationName,organisationId) => {
    const searchQuery = {
        name: null,
        sorting: null,
        sortOrder: 'ASC',
        skipCount: 0,
        maxResultCount: 2500
    }
    searchQuery.name=organizationName
    const response = await api.get(endpoints.admin.org.concat('?', queryString.stringify(searchQuery)));
    if (response && response.status === 200) {
        
        if (response?.data?.items) {
            let duplicate = false; 
            for (const o of response.data.items) {
                duplicate = o.organizationName === organizationName && o.id !== organisationId
            }
            return duplicate;
        }
        return true; // if there's a problem wwe assume there's a duplicate
    } else {
        // if we can't get the data we assume it's duplicate because we don't want to create eon
        return true;
    }
}
